import { Interweave } from 'interweave';
import React, { FC } from 'react';
import IInfoText from '../../interfaces/umbracoNodes/infoText';
import { Column, Columns } from '../base/grid';
import RichTextStyleWrapper from '../base/richTextStyleWrapper';
import * as StyledIconTextList from './iconTextList.styles';

interface Props {
	list: IInfoText[];
}

const IconTextList: FC<Props> = ({ list }) => {
	return (
		<StyledIconTextList.Wrapper>
			<Columns>
				{list.map((listItem, index) => (
					<Column tablet={(list.length > 1) ? 1/2 : 1} key={index}>
						<StyledIconTextList.TextWrapper>
							<StyledIconTextList.InfoTextTitleWrapper>
								<StyledIconTextList.IconTextImage
									src={`/dist/icons/${listItem.Values.Icon}.svg`}
									alt={`${listItem.Values.Text}`}
								/>
								<StyledIconTextList.IconTextTitle>
									{listItem.Values.Title}
								</StyledIconTextList.IconTextTitle>
							</StyledIconTextList.InfoTextTitleWrapper>
							<StyledIconTextList.IconText>
								<RichTextStyleWrapper>
									<Interweave content={listItem.Values.Text} />
								</RichTextStyleWrapper>
							</StyledIconTextList.IconText>
						</StyledIconTextList.TextWrapper>
					</Column>
				))}
			</Columns>
		</StyledIconTextList.Wrapper>
	);
};

export default IconTextList;
